<script>
import DatePicker from "vue2-datepicker";
import SubscriberReading from '@/components/widgets/subscriber-reading.vue'

let dateNow = new Date();
export default {
    name: 'ServiceUnpaid',
    components: {
        DatePicker,
        SubscriberReading
    },
    props: {
        loading: Boolean,
        items: {
            type: Array,
            default: () => [],
        },
        service: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            dateFrom: new Date(dateNow.getFullYear(), dateNow.getMonth(), 1),
            dateTo: new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 0),
            menuSelection: 1,
        }
    },
    watch: {
        menuSelection: function (newVal) {
            if (newVal == 1) {
                this.loadSummary();
            } else if (newVal == 2) {
                this.loadData();
            }
        },
    },
    computed: {
        selectedReadings() {
            return this.items.filter(item => item.selected);
        },
        selectAllReadings: {
            get() {
                return this.items.length ? this.items.every(item => item.selected) : false;
            },
            set(value) {
                this.items.forEach(item => {
                    item.selected = value;
                });
            }
        },
    },
    methods: {
        loadData() {
            return this.$emit('load-data', {dateFrom: this.getDate(this.dateFrom), dateTo: this.getDate(this.dateTo)});
        },
        loadSummary() {
            return this.$emit('load-summary');
        },
        formatInclusiveDates(string) {
            if (!string) return '';
            let date = string.split(' - ');
            if(!date[0]) return `${this.formatDateShort(new Date(date[1]))}`;
            return `${this.formatDateShort(new Date(date[0]))} - ${this.formatDateShort(new Date(date[1]))}`;
        },
        async getSubscriberReading(item) {
            item.viewReading = !item.viewReading;
            if(!item.viewReading) return;
            await this.wait(100);
            this.$refs[`subscriberReading${item.id}`][0].getData(item, 2);
        },
        printReading(item) {
            this.$emit('printReading', item);
        },
    }
}
</script>
<template>
  <div>
    <div class="d-flex justify-content-between mb-2">
        <div class="d-flex align-items-center">
            <template v-if="menuSelection == 2">
                <p class="mb-0 me-2">From:</p>
                <date-picker
                    id="fromDate"
                    v-model="dateFrom"
                    :first-day-of-week="1"
                    lang="en"
                    format="MMMM DD, YYYY"
                    placeholder="Enter Start Date..."
                    @change="loadData()"
                >
                </date-picker>
                <p class="mb-0 mx-2">To</p>
                <date-picker
                    id="toDate"
                    v-model="dateTo"
                    :first-day-of-week="1"
                    lang="en"
                    format="MMMM DD, YYYY"
                    placeholder="Enter End Date..."
                    @change="loadData()"
                >
                </date-picker>
                <button class="btn btn-purple no-wrap ms-2" v-if="selectedReadings.length" @click="$emit('generate-readings', selectedReadings)" >
                    <i class="bx bx-printer"></i> Generate Billing ({{selectedReadings.length}})
                </button>
            </template>
        </div>
        <div>
            <div class="d-flex gap-1">
                <div class="border pur-list" :class="{'active': menuSelection == 1}" @click="menuSelection = 1">Summary</div>
                <div class="border pur-list" :class="{'active': menuSelection == 2}" @click="menuSelection = 2">Date Range</div>
            </div>
        </div>
    </div>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th class="text-center p-0 align-middle" style="width:50px;" :class="{'cursor-pointer': menuSelection == 2}" @click="selectAllReadings = !selectAllReadings">
                    <i class="bx text-green font-size-20 font-weight-bold  p-0" :class="{'bx-check': selectAllReadings}" v-if="menuSelection == 2"></i>
                </th>
                <th class="">Subscriber</th>
                <th class="text-center" v-if="menuSelection == 2">Inclusive Dates</th>
                <th class="text-center" v-if="menuSelection == 2">Due Date</th>
                <th class="text-center" style="width:180px;">Amount</th>
                <th class="text-center" style="width:180px;" v-if="menuSelection == 2">Created By</th>
            </tr>
        </thead>
        <tbody>
            <tr v-if="loading">
                <td colspan="100%" class="text-center" >Loading...</td>
            </tr>
            <template v-else>
                <tr v-if="!items.length">
                    <td colspan="100%" class="text-center">No data available</td>
                </tr>
                <template v-else>
                    <template v-for="(item, index) in items">
                        <tr :key="`A${index}`">
                            <template v-if="menuSelection == 2">
                                <td class="text-center p-0 align-middle cursor-pointer" @click="item.selected = !item.selected"> 
                                    <i class="bx text-green font-size-20 font-weight-bold p-0" :class="{'bx-check': item.selected}"></i>
                                </td>
                            </template>
                            <template v-else>
                                <td class="text-center p-0 align-middle cursor-pointer" @click="getSubscriberReading(item)"> 
                                    <i class="bx font-size-20 font-weight-bold" :class="{
                                        'bx-chevron-right': !item.viewReading,
                                        'bx-chevron-down': item.viewReading,
                                    }"></i>
                                </td>
                            </template>
                            <td>
                                <template v-if="menuSelection == 2">
                                    <a href="javascript:void(0)" class="font-weight-bold text-white hover-underline" @click="item.selected = !item.selected">
                                        {{ item.accountNumber }}: {{ item.subscriber }}
                                    </a>
                                </template>
                                <template v-else>
                                    <a href="javascript:void(0)" class="font-weight-bold text-white hover-underline" @click="getSubscriberReading(item)">
                                    {{ item.subscriber }}
                                    </a>
                                </template>
                            </td>
                            <td class="text-center" v-if="menuSelection == 2">{{ formatInclusiveDates(item.inclusiveDate) }}</td>
                            <td class="text-center" v-if="menuSelection == 2">{{ formatDateShort(new Date(item.dueDate)) }}</td>
                            <td class="text-center">{{ formatCurrency(menuSelection == 2 ? item.amount : item.totalAmount) }}</td>
                            <td class="text-center" v-if="menuSelection == 2">{{ item.createdBy }}</td>
                        </tr>
                        <tr :key="`B${item.id}`" v-if="item.viewReading">
                            <td></td>
                            <td colspan="100% - 1">
                                <SubscriberReading 
                                    menuType="unpaid"
                                    :ref="`subscriberReading${item.id}`"
                                    :service="service"
                                    @printReading="printReading"
                                />
                            </td>
                        </tr>
                    </template>
                </template>
            </template>
        </tbody>
    </table>
  </div>
</template>